import React from 'react';
import ReleaseManagerContainer from 'components/app/tool/releases/ReleaseManagerContainer';

const Releases = () => {
    return <ReleaseManagerContainer />;
};

export default Releases; 